<template>
  <ButtonDefault
    :button-name="$t('shooting.buttons.download.download')"
    :outlined="true"
    :loading="loading"
    @click="downloadVideo"
  />
</template>

<script>
import { mapState } from 'vuex'
import axios from 'axios'
import download from 'downloadjs'
import ButtonDefault from '@/components/common/atoms/ButtonDefault.vue'

export default {
  name: 'DownloadVideoButton',
  components: {
    ButtonDefault
  },

  data() {
    return {
      loading: false
    }
  },

  props: {
    url: String
  },

  computed: {
    ...mapState({
      video: state => state.video
    })
  },

  methods: {
    async downloadVideo() {
      const url = this.video && this.video.url

      if (!url) return
      this.loading = true
      const res = await this.downloadBlob(url)

      if (!res) {
        const snackMessage = this.$t('api.downloadFileError')
        this.$store.commit('SET_SNACKBAR', { snack: snackMessage, color: 'error' })
      } else {
        download(res.data)
      }

      this.loading = false
    },

    async downloadBlob(url) {
      try {
        return await axios({
          method: 'get',
          url: url,
          responseType: 'blob'
        })
      } catch (e) {
        return false
      }
    }
  }
}
</script>
